export const environment = {
	webBase: 'https://vivascore.alula.health',
	appEnvironmentBaseUrl: 'https://api.alulahealth.com/health/environment',
	deeplinkURL: 'vivascore://',

	dislaimerUrl: 'https://vivascore.ai/disclaimer/',
	privacyPolicy: 'https://vivascore.ai/privacy-policy/',
	termsOfUse: 'https://vivascore.ai/terms-of-use/',
	faqUrl: 'https://vivascore.ai/faq/',
	useHelpCenter: true,
	aboutUsUrl: 'https://vivascore.ai/press-release/',
	contactUsUrl: 'https://vivascore.ai/book-a-demo/',
	welcomeBackground: '/assets/v2/welcome/background.png',
	authPageLogoFallback: undefined as string | undefined,

	oneSignalAppId: 'fc358462-7175-4b89-9bf5-13224240e909',
	environmentName: 'production',
	production: true,
	apiProduction: true,
	showUatBuildBanner: false,
	includeFaceScanReportEmailMessage: true,

	countryCode: undefined as string | undefined,
	organizationId: undefined as string | undefined,
	scanFriendAllowed: true,
	pnExternalServicesBaseUrl: undefined as string | undefined,
	enableMobileRegistation: true,
	enableWebRegistation: true,

	enableLocalAccounts: true,
	enableExternalLogin: true,

	enableEnterpriseRegistration: false,

	iosAuthRedirect: 'msauth.com.alulahealth.vitalscore://auth',
	androidAuthRedirect: 'msauth://com.alulatechnologies.vitalscore/2jmj7l5rSw0yVb%2FvlWAYkK%2FYBwk%3D',


	whatsappEnabled: false,
	enableRewardsPartner: true,

	androidStoreLink: 'https://play.google.com/store/apps/details?id=com.alulatechnologies.vitalscore',
	iosStoreLink: 'https://apps.apple.com/app/id6448233085',

	defaultCulture: 'en-GB',
	// Omit availablelanguages to inherit shared-config catalog (full BCP-47 list).

	availablelanguages: [
		{ culture: 'en-ZA', text: 'English (South Africa)', dir: 'ltr' },
		{ culture: 'en-GB', text: 'English (United Kingdom)', dir: 'ltr' },
		{ culture: 'en-US', text: 'English (United States)', dir: 'ltr' },
		{ culture: 'af-ZA', text: 'Afrikaans', dir: 'ltr' },
		{ culture: 'it-IT', text: 'Italiano', dir: 'ltr' },
		{ culture: 'ur-PK', text: 'اردو', dir: 'rtl' },
		{ culture: 'de-DE', text: 'Deutsch', dir: 'ltr' },
		{ culture: 'fr-FR', text: 'Français', dir: 'ltr' },
		{ culture: 'es-ES', text: 'Español (España)', dir: 'ltr' },
		{ culture: 'es-MX', text: 'Español (México)', dir: 'ltr' },	
		{ culture: 'nl-NL', text: 'Nederlands', dir: 'ltr' },
	],

	E2E_TEST_MODE: false, // Set to true when running E2E tests to enable mock API services

	hca_gb:'c196e445-ddd5-4acf-b3a9-08dd3b80c737'

};

